var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000302608 12C-0.0325287 11.9172 2.61039 9.16965 5.86069 5.92552C9.11099 2.66483 11.8852 0 12.0166 0C12.1479 0 13.9208 1.67172 19.6498 7.44828L12.0166 15.1448L8.89759 12L13.4119 7.44828L12.0166 6.04138L6.10693 12L12.0166 17.9586L21.0452 8.85517L22.5226 10.3448C23.3434 11.1724 24 11.9172 24 12C24 12.0828 21.3571 14.8303 18.1396 18.0745C14.9057 21.3352 12.1479 24 12.0166 24C11.8852 24 9.12741 21.3352 5.90994 18.091C2.67606 14.8303 0.0167183 12.0993 0.000302608 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergi);
export default __webpack_public_path__ + "static/media/energi.6e04a2258ee3a3210dd105bff9c27055.svg";
export { ForwardRef as ReactComponent };